module.exports = __webpack_public_path__ + "static/img/8.d7002dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/8.png
// module id = qORJ
// module chunks = 0